import { render, staticRenderFns } from "./MergeTag.vue?vue&type=template&id=48a8c30c"
import script from "./MergeTag.vue?vue&type=script&lang=js"
export * from "./MergeTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports